<template>
  <div v-if="shouldShow" class="vg-confirmation-recap__cancel">
    <p
      v-if="isCancelled"
      class="vg-confirmation-recap__cancel-status"
      role="status"
    >
      {{ $t("messages.orderCancelled") }}
    </p>
    <p
      v-else-if="hasExpiredError"
      class="vg-confirmation-recap__cancel-status vg-confirmation-recap__cancel-status--error"
      role="alert"
    >
      {{ $t("messages.cancelOrderExpiredError") }}
    </p>
    <p
      v-else-if="hasError"
      class="vg-confirmation-recap__cancel-status vg-confirmation-recap__cancel-status--error"
      role="alert"
    >
      {{ $t("messages.cancelOrderError") }}
    </p>
    <p v-else class="vg-confirmation-recap__cancel-action">
      <a
        href="#"
        class="vg-confirmation-recap__cancel-link"
        :class="{ disabled: isProcessing }"
        @click.prevent="cancelOrder"
      >
        {{ $t("messages.cancelOrderRecapLink") }}
      </a>
    </p>
  </div>
</template>

<script>
import Orion from "@/services/orion";
import { shouldApplyConfirmationCancelPolicy } from "@/services/confirmationOrder";
import {
  ensureConfirmationOfferWindowStart,
  isConfirmationOfferWindowExpired,
} from "@/services/confirmationOfferWindow";

export default {
  name: "CancelOrderLink",
  props: {
    order: {
      type: Object,
      required: true,
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  emits: ["cancelled"],
  data() {
    return {
      isCancelled: false,
      isProcessing: false,
      hasError: false,
      hasExpiredError: false,
    };
  },
  mounted() {
    if (this.shouldShow && localStorage.getItem(this.cancelledKey)) {
      this.isCancelled = true;
      this.$emit("cancelled");
    }

    if (this.shouldShow && this.order?.externalOrderId) {
      ensureConfirmationOfferWindowStart(this.order.externalOrderId);
    }
  },
  computed: {
    cancelledKey() {
      return `order_cancelled_${this.order?.externalOrderId}`;
    },
    shouldShow() {
      return shouldApplyConfirmationCancelPolicy(this.order, this.step);
    },
  },
  methods: {
    cancelOrder() {
      if (this.isProcessing || this.isCancelled) return;
      if (!this.order.externalOrderId) return;

      if (isConfirmationOfferWindowExpired(this.order.externalOrderId)) {
        this.hasExpiredError = true;
        this.hasError = false;
        return;
      }

      this.isProcessing = true;
      this.hasError = false;
      this.hasExpiredError = false;

      Orion.cancelOrder(this.order.externalOrderId)
        .then(() => {
          this.isCancelled = true;
          this.$emit("cancelled");
          localStorage.setItem(this.cancelledKey, "true");
        })
        .catch((error) => {
          console.error("Cancel order failed:", error);
          this.hasError = true;
          this.isProcessing = false;
        });
    },
  },
};
</script>
